import {
  DOUGS_PARTNER_DISPLAY_NAME,
  DOUGS_PARTNER_IDENTIFIERS,
} from '@repo/company-creation-kit/common/constants/dougs';
import { usePartnerName } from './use-partner-name';

export function useIsCobrandedDougs(): boolean {
  const partnerName = usePartnerName();

  if (!partnerName) {
    return false;
  }

  return DOUGS_PARTNER_IDENTIFIERS.includes(partnerName.toLowerCase());
}

export function useDougsPartnerName(): string | undefined {
  const isCobrandedDougs = useIsCobrandedDougs();
  return isCobrandedDougs ? DOUGS_PARTNER_DISPLAY_NAME : undefined;
}
